export default __webpack_public_path__ + "static/media/DDealW.14059f61.svg";